import { reducer as employeesReducer } from './model/employees';

export * as EmployeesModel from './model';
export { EmployeesUi } from './ui';

export default employeesReducer;
